import { LaunchpadOverlay as LegacyLaunchpadOverlay } from "src/app/core/interfaces/overlay";
import { LaunchpadType } from "./launchpad.interfaces";

export const convertFromLegacyOverlay = (overlay: LegacyLaunchpadOverlay): LaunchpadType =>
  overlay === "module" ? "regulated" : "marketplace";
export const convertToLegacyOverlay = (overlay: LaunchpadType): LegacyLaunchpadOverlay =>
  overlay === "regulated" ? "module" : "plugin";
